import { useMemo } from 'react';

import useSWR from 'swr';
import { immutable } from 'swr/immutable';

import { QrScanHelpers } from 'helpers/QrScanHelpers';
import { ShowtimeHelpers } from 'helpers/ShowtimeHelpers';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { ShowtimeService } from 'services/ShowtimeService';

const useQrScansByCompany = ({ companyId, refreshable = false }: { companyId: string; refreshable?: boolean }) => {
    const swr = useSWR(
        ...prepareConditionalSwrArgs({
            key: ShowtimeHelpers.swr.qrScansByCompany(companyId),
            fetcher: () => ShowtimeService.getQrScansByCompany({ companyId }),
            condition: Boolean(companyId),
        }),
        refreshable ? { refreshInterval: 60 * 1000 } : { use: [immutable] },
    );

    const qrScans = swr.data || [];
    const leads = useMemo(() => QrScanHelpers.groupByVisitor(qrScans), [swr.data]);

    return {
        qrScans,
        leads,
        ...swr,
    };
};

export { useQrScansByCompany };
